import { Stack } from '@mui/material'
import React from 'react'
import { IconButton } from 'utoniq-ui'

import { ItemThumbnailType } from '@/clients/utoniq-core/schema'
import { ItemReversibleThumbnail } from '@/components/organisms'
import { VoicePlayer } from '@/components/organisms/resourcePlayer/VoicePlayer'
import { ThumbnailActionAreaCell } from '@/components/pages/OwnedItemDetail/template/components/ThumbnailActionArea'
import { CellFrame, Organism } from '@/core/architecture'

import type { State } from '../../../viewModel'
import { ItemDescriptionCell } from '../ItemDescription'
import { SupplementLinkSetCell } from '../SupplementLinkSet'

export type Props = {
  loading: boolean
  portfolio: State['portfolio']
  isFlipped: boolean
  onReverseThumbnail: () => void
  onSetAvatar: () => Promise<void>
  onClickProtectUserItem: () => void
  onOpenFullScreen?: () => void
  onOpenMultipleImage?: () => void
}

export const OwnedItemDetailAvatarView: Organism<Props> = ({
  loading,
  portfolio,
  isFlipped,
  onReverseThumbnail,
  onSetAvatar,
  onClickProtectUserItem,
  onOpenFullScreen,
  onOpenMultipleImage,
}) => {
  const voiceResource = portfolio?.item.avatarResources?.voiceResource

  return (
    <CellFrame
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: '1 0 auto',
      }}
    >
      <Stack
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        flex={1}
      >
        <Stack
          alignItems="center"
          sx={{
            position: 'relative',
            '.MuiButtonBase-root': {
              height: 'fit-content',
            },
          }}
        >
          <ThumbnailActionAreaCell
            onOpenFullScreen={onOpenFullScreen}
            onOpenMultipleImage={onOpenMultipleImage}
            numberImage={portfolio?.item.images?.length ?? 0}
          />
          <ItemReversibleThumbnail
            loading={loading}
            flipProps={{
              isFlipped,
            }}
            imageAreaProps={{
              thumbnail: portfolio?.item?.thumbnail,
              size:
                portfolio?.item.thumbnailType === ItemThumbnailType.Square
                  ? 'x-large-square'
                  : 'x-large',
              onClick: onReverseThumbnail,
            }}
          />
        </Stack>
        <ItemDescriptionCell portfolio={portfolio} />
        <Stack sx={{ mt: 4, mb: 2 }} direction="row" spacing={6}>
          {voiceResource ? (
            <VoicePlayer
              resource={voiceResource}
              bgcolor="primary.main"
              color="white"
            />
          ) : (
            <IconButton.Rotate
              size="small"
              onClick={onReverseThumbnail}
              bgcolor="primary.main"
              color="white"
            />
          )}
          <IconButton.Avatar
            size="small"
            onClick={onSetAvatar}
            bgcolor="primary.main"
            color="white"
          />
        </Stack>
      </Stack>
      <SupplementLinkSetCell
        sku={portfolio?.item.sku}
        itemId={portfolio?.item.id}
        commentCount={portfolio?.item.commentCount}
        relatedMissions={portfolio?.item.relatedMissions}
        artistId={portfolio?.item.issuedArtist?.id ?? ''}
        isUserProtected={portfolio?.isUserProtected}
        issuableNft={!!portfolio?.item.nft?.chains}
        onClickProtectUserItem={onClickProtectUserItem}
      />
    </CellFrame>
  )
}
